import React from "react";
import { Box, Stack } from "@mui/material";
import TallyButton from "../../common/TallyButton.tsx";
import { Trans } from "@lingui/react/macro";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../../hooks.tsx";
import { conversationActions } from "../../../store/conversation.tsx";
import handleSignUp from "./handleSignUp.tsx";

const SignUpOptions: React.FC = () => {
  const dispatch = useDispatch();
  const anonymousSession = useTypedSelector(
    (state) => state.authState.anonymousSession,
  );

  const handleClick = async (providerLabel: string) => {
    dispatch(
      conversationActions.appendCustomActionPrompt({
        text: providerLabel,
        type: "TextResponse",
      }),
    );

    await handleSignUp({
      searchText: providerLabel,
      dispatch,
      signUpState: anonymousSession?.signUpState,
    });
  };

  return (
    <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
      <Stack direction="row" spacing={2}>
        <TallyButton variant="outlined" onClick={() => handleClick("Google")}>
          <Trans context="Single sign-on option button label">Google</Trans>
        </TallyButton>
        <TallyButton
          variant="outlined"
          onClick={() => handleClick("Visma Connect")}
        >
          <Trans context="Single sign-on option button label">
            Visma Connect
          </Trans>
        </TallyButton>
      </Stack>
    </Box>
  );
};

export default SignUpOptions;
